import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		header: {
			display: "flex",
			flex: 1,
			justifyContent: "space-between",
			alignItems: "center",
		},
		pipelineSection: {
			margin: theme.spacing(2, 0),
		},
		pipelineDividerTop: {
			marginBottom: theme.spacing(4),
		},
		pipelineDividerBottom: {
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(6),
		},
		tabIcon: {
			fontSize: 13,
		},
	} satisfies Record<string, CSSObject>;
};
